import React from 'react'
import { BaseDetail } from 'App/Component/Bases'
// import fields from './fields'
import fields from 'App/Screens/Estimation/ProductParentGroups/fields';

class FormAdd extends BaseDetail {
  title = 'Product Parent Group';
  urlData = 'module-product-productParentGroup';
  fields = fields;
  state = {
    isCheckingPermission: false,
    isAccessAllowed: true,
  }
}

class PageAdd extends React.Component {
  render() {
    return (
      <FormAdd {...this.props} />
    )
  }
}

export default PageAdd